import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
    overflow: 'hidden',
  },
  /** Takes the height the panel has left, so rows run to the bottom. */
  scrollArea: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    overflowY: 'auto',
  },
  /** Sits outside the scroller, so it stays put while the rows move under it. */
  titleRow: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    backgroundColor: theme.palette.bg.light,
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.labraText.darkTertiary,
    '& svg': { fontSize: 14 },
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    color: theme.palette.labraText.darkTertiary,
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  groupLabel: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 11,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.palette.labraText.secondaryDescription,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: theme.palette.labraChat.hoverBg,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    width: '100%',
    minHeight: theme.spacing(5.5),
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    borderRadius: 8,
    border: 'none',
    // Each row is a white card on the container's grey ground.
    backgroundColor: theme.palette.text.white,
    cursor: 'pointer',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: theme.palette.labraChat.hoverBgAlt,
    },
    // The chevron is the row's own affordance, so it waits for the hover.
    '&:hover .chatRecommendationChevron': {
      visibility: 'visible',
    },
  },
  rowIcon: {
    flexShrink: 0,
    display: 'flex',
    fontSize: 14,
    color: theme.palette.labraText.description,
    // GradientFaIcon renders a bare <svg>, which has no font-size to inherit.
    '& svg': { width: 14, height: 14 },
  },
  rowText: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.palette.labraText.tertiary,
  },
  rowChevron: {
    flexShrink: 0,
    visibility: 'hidden',
    display: 'flex',
    fontSize: 12,
    color: theme.palette.labraText.description,
  },
  moreButton: {
    alignSelf: 'flex-start',
    flexShrink: 0,
    // Holds the link's height while the spinner stands in for the label.
    display: 'flex',
    alignItems: 'center',
    minHeight: theme.spacing(2),
    border: 'none',
    background: 'none',
    padding: 0,
    cursor: 'pointer',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
    color: theme.palette.textBlueV3.main,
  },
  empty: {
    fontFamily: theme.typography.fontFamily,
    fontSize: 13,
    color: theme.palette.labraText.description,
  },
}))
